import script from "./LlTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./LlTabs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__